import React, { useMemo, useRef } from "react";
import { BlogCard } from "./BlogCard";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Img } from "../../components/shared/img";
import { useQueryParams } from "../../hooks/useQueryParams";
import { usePagination } from "../../hooks/usePagination";
import { useHistory, useLocation } from "react-router-dom";
import { PaginationControls } from "../../components/shared/pagination-controls";

/**
 * Renderiza las reseñas o entradas en la pagina principal del blog
 * @param {object} resena - contiene la información de las reseñas
 * @param {object} textosBlog - contiene los textos de interfaz
 * @returns {JSX.Element} Posts
 */
export const Posts = ({ resena, textosBlog }) => {
    const reviewData = resena?.data;
	const reviews = useMemo(() => {
		return Array.isArray(reviewData) ? reviewData : [];
	}, [reviewData]);

	const location = useLocation();
	const history = useHistory();

	const listRef = useRef(null);

	const params = useQueryParams();
	const page = params.get("page") ? Number(params.get("page")) : 1;
	const pagination = usePagination({
		itemsPerPage: 6,
		data: reviews,
		defaultPage: page,
		onChangePage: (_page) => {
            if (location.pathname === "/blog" && resena?.loading === false && reviews.length > 0) {
				history.replace({ pathname: location.pathname, search: `?page=${_page}` });
			}
		},
	});
	const currentPageData = pagination?.currentPageData;

	const scrollToListTop = () => {
		if (!listRef.current) return;
        setTimeout(() => {
            window.scrollTo(0, listRef.current.offsetTop - 200);
        }, 150)
	};

    if(resena.loading === true && resena?.data?.length === 0){
        return (
            <>
                <div
                    className="secondary-inverse--color container-fluid w-100 d-flex justify-content-center align-items-center col-md-10 col-lg-10"
                    style={{minHeight: 400}}    
                >
                    <Icon icon="icomoon-free:spinner9" width={60} className={'spinner-rotation'} />
                </div>
            </>
        )
    }


    return (
        <>
            {
                resena?.loading ?
                    <>
                        <div
                            className="secondary-inverse--color container-fluid w-100 d-flex justify-content-center align-items-center col-md-10 col-lg-10"
                            style={{minHeight: 400}}    
                        >
                            <Icon icon="icomoon-free:spinner9" width={60} className={'spinner-rotation'} />
                        </div>
                    </>
                    :
                    <>

                        {
                            reviews?.length === 0 ?
                                <div >
                                    <Img
                                        src={`/img/noresults.png`}
                                        style={{ maxWidth: 150 }}
                                    />
                                    <p className="text-center onbackground-primary--color py-3">
                                        {textosBlog?.entrada?.no_resultados || 'No se encontraron resultados en la búsqueda :('}
                                    </p>
                                </div>

                                :

                                <>
                                    <div
                                        style={{ overflow: 'visible' }}
                                        className='row mt-4 mt-lg-5'
                                        ref={listRef}
                                    >
                                        {
                                            currentPageData?.map((item, i) => {
                                                return (
                                                    <div key={`reseña-${item?.title}-${i}`} className="col-lg-6 mb-5 mb-lg-4">
                                                        <BlogCard InfoCard={item} textosBlog={textosBlog} />
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                            {pagination.totalPages > 1 && (
                                <PaginationControls
                                    onClickPrev={() => {
                                        pagination.prevPage();
                                        scrollToListTop();
                                    }}
                                    onClickNext={() => {
                                        pagination.nextPage();
                                        scrollToListTop();
                                    }}
                                    onClickPage={(page) => {
                                        pagination.goToPage(page);
                                        scrollToListTop();
                                    }}
                                    currentPage={pagination.currentPage}
                                    totalPages={pagination.totalPages}
                                    range={pagination.range}
                                />
                            )}

                                </>

                        }

                    </>
            }

        </>
    )
}